<div class="day-slider-container">
  <div class="day-slider-content" [class.disabled-interaction]="showCalendarPopup">
    <button class="nav-button prev-button" (click)="scrollDays('left')" aria-label="Previous days">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>

    <!-- Update the days container to properly handle scroll without selection -->
    <div class="days-container" 
         #daysContainer 
         (scroll)="onScroll()" 
         (touchstart)="$event.stopPropagation()"
         (touchmove)="$event.stopPropagation()"
         (touchend)="preventTouchSelection($event)">
      @for (day of days; track day) {
        <div 
          class="day-column" 
          [class.disabled]="disablePastDays && isPastDay(day.date)"
          (click)="selectDay(day)"
          >
          <!-- Day content remains unchanged -->
          <div class="day-name">{{ dayNames[day.date.getDay()] }}</div>
          
          <div 
            class="day-circle"
            [class.selected]="isSelected(day.date)"
            [class.today]="day.isToday"
            (click)="selectDay(day)"
            [class.past-day]="isPastDay(day.date) && disablePastDays">
            {{ day.date.getDate() }}
          </div>
          
          <div class="month-name">{{ getShortMonth(day.date) }}</div>
        </div>
      }
    </div>

    <button class="nav-button next-button" (click)="scrollDays('right')" aria-label="Next days">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </div>
</div>